// @ts-nocheck
/**
 * MERLİN ✦ ALIŞVERİŞ DANIŞMANI — KANONİK ASTRA PREMİUM RUNTIME
 * Kanonik Referans: panel/components/merlin-musteri-deneyimi.tsx
 * P0 İlkesi: Sıfır Bağımlılık, Hata İzolasyonu, Kesintisiz Alışveriş
 */

(function initMerlinAdvisor() {
  'use strict';

  function safeRun(fn) {
    try {
      fn();
    } catch (err) {
      console.warn('[MERLİN] Safe-fail notice:', err);
    }
  }

  safeRun(function () {
    const STATE = {
      isOpen: false,
      origin: 'header',
      productInfo: null,
      collectionInfo: null,
      cartItems: [],
    };

    function detectCollectionContext(triggerEl) {
      let colId = triggerEl?.dataset?.collectionId || '';
      let colTitle = triggerEl?.dataset?.collectionTitle || '';
      let colHandle = triggerEl?.dataset?.collectionHandle || '';
      let colProducts = triggerEl?.dataset?.collectionProducts
        ? triggerEl.dataset.collectionProducts.split(',').map(function (s) { return s.trim(); }).filter(Boolean)
        : [];

      if (!colTitle || !colHandle) {
        const metaEl = document.getElementById('merlin-collection-meta');
        if (metaEl) {
          try {
            const meta = JSON.parse(metaEl.textContent || '{}');
            if (meta.title) colTitle = meta.title;
            if (meta.handle) colHandle = meta.handle;
            if (meta.id) colId = meta.id;
            if (Array.isArray(meta.product_ids) && meta.product_ids.length > 0) {
              colProducts = meta.product_ids.map(String);
            }
          } catch (_) {}
        }
      }

      if (!colHandle && window.location.pathname.includes('/collections/')) {
        const match = window.location.pathname.match(/\/collections\/([^/?#]+)/);
        if (match && match[1] && match[1] !== 'all') {
          colHandle = match[1];
        }
      }

      if (!colTitle && colHandle) {
        const h1 = document.querySelector('.collection-title, h1[data-collection-title], .collection__title, h1');
        if (h1 && window.location.pathname.includes('/collections/')) {
          colTitle = h1.textContent?.trim() || '';
        }
      }

      if (colProducts.length === 0 && window.location.pathname.includes('/collections/')) {
        const pEls = document.querySelectorAll('[data-product-id]');
        const ids = [];
        pEls.forEach(function (el) {
          const pid = el.dataset.productId;
          if (pid && !ids.includes(pid)) ids.push(pid);
        });
        if (ids.length > 0) colProducts = ids.slice(0, 20);
      }

      if (colTitle || colHandle) {
        return {
          id: colId,
          title: colTitle || (colHandle.replace(/-/g, ' ')),
          handle: colHandle,
          product_ids: colProducts,
        };
      }
      return null;
    }

    function getElements() {
      return {
        backdrop: document.getElementById('merlin-advisor-backdrop'),
        closeBtn: document.getElementById('merlin-advisor-close'),
        scrollArea: document.getElementById('merlin-customer-scroll'),
        streamArea: document.getElementById('merlin-stream'),
        contextRibbon: document.getElementById('merlin-context-ribbon'),
        contextText: document.getElementById('merlin-context-text'),
        productSlot: document.getElementById('merlin-product-slot'),
        dynamicHeading: document.getElementById('merlin-dynamic-heading'),
        dynamicIntro: document.getElementById('merlin-dynamic-intro'),
        followupText: document.getElementById('merlin-followup-text'),
        input: document.getElementById('merlin-chat-input'),
        form: document.getElementById('merlin-chat-form'),
      };
    }

    function cleanProductTitle(rawTitle) {
      if (!rawTitle) return 'Seçili Parça';
      let t = rawTitle;
      t = t.replace(/^Kadın\s+/i, '').replace(/^Erkek\s+/i, '');
      t = t.replace(/,\s*\d+\s*cm/gi, '');
      if (t.includes('|')) {
        t = t.split('|')[0].trim();
      }
      if (t.includes('–')) {
        const parts = t.split('–');
        const p1 = parts[0].trim();
        const p2 = parts[1].trim();
        if (p2.length > 2 && p2.length < 35) {
          const cat = p1.toLowerCase().includes('hırka') ? 'Triko Hırka'
                    : p1.toLowerCase().includes('avize') ? '3D Avize'
                    : p1.toLowerCase().includes('takım') ? 'Takım'
                    : p1.toLowerCase().includes('tayt') ? 'Tayt'
                    : p1.toLowerCase().includes('pantolon') ? 'Pantolon'
                    : p1;
          t = p2 + ' ' + cat;
        } else {
          t = p1;
        }
      } else if (t.includes('—')) {
        t = t.split('—')[0].trim();
      }
      t = t.replace(/\s+/g, ' ').trim();
      if (t.length > 36) {
        t = t.substring(0, 34) + '…';
      }
      return t;
    }

    function classifyItem(item) {
      const t = (item.title || '').toLowerCase();
      // 1. Avize & Aydınlatma
      if (t.includes('avize') || t.includes('sarkıt') || t.includes('lamba') || t.includes('aydınlatma') || t.includes('aplik')) {
        return 'avize';
      }
      // 2. 3D Ev & Masaüstü Dekorasyon Objesi
      if (t.includes('tepsi') || t.includes('figür') || t.includes('obje') || t.includes('vazo') || t.includes('saksı') || t.includes('düzenleyici') || t.includes('organizer') || t.includes('kedi') || t.includes('heykel') || t.includes('biblo') || t.includes('mumluk') || t.includes('dekoratif') || t.includes('baskı') || t.includes('pla') || t.includes('3d')) {
        return 'dekorasyon';
      }
      // 3. İkili Takım & Eşofman
      if (t.includes('takım') || t.includes('esofman') || t.includes('eşofman')) {
        return 'takim';
      }
      // 4. Alt Giyim (Pantolon, Tayt, Etek, Şort...)
      if (t.includes('pantolon') || t.includes('tayt') || t.includes('şort') || t.includes('jogger') || t.includes('etek')) {
        return 'alt';
      }
      // 5. Triko & Hırka
      if (t.includes('hırka') || t.includes('triko') || t.includes('kazak') || t.includes('süveter') || t.includes('şal yaka')) {
        return 'triko';
      }
      // 6. Üst Giyim (Gömlek, Bluz, Tişört...)
      if (t.includes('gömlek') || t.includes('bluz') || t.includes('body') || t.includes('tişört') || t.includes('t-shirt') || t.includes('crop')) {
        return 'ust';
      }
      // 7. Elbise
      if (t.includes('elbise') || t.includes('dress')) {
        return 'elbise';
      }
      // 8. Dış Giyim (Ceket, Trençkot, Kaban...)
      if (t.includes('ceket') || t.includes('trençkot') || t.includes('kaban') || t.includes('mont') || t.includes('palto')) {
        return 'dis';
      }
      return 'giyim_diger';
    }

    function generateCartAdvisorInsight(cartItems, totalVal) {
      if (!cartItems || cartItems.length === 0) {
        return {
          heading: 'Sepetiniz İçin Kişisel Stil Rehberiniz',
          intro: 'Sepetinize ekleyeceğiniz ürünlerin doğrulanmış ölçü, malzeme ve bakım bilgilerini birlikte değerlendirebiliriz.'
        };
      }

      return {
        heading: cartItems.length > 1
          ? 'Sepetinizdeki seçimleri birlikte karşılaştıralım'
          : 'Seçtiğiniz ürünü birlikte değerlendirelim',
        intro: 'Sepetinizdeki ' + cartItems.length + ' ürün için yalnız canlı mağaza bağlamını ve yayımlanmış ürün bilgilerini kullanırım. Doğrulanmamış kumaş, kalıp veya kullanım iddiası üretmem.'
      };
    }

    function updateTopicOptions(topics) {
      const container = document.querySelector('.merlin-topic-options');
      if (!container || !Array.isArray(topics) || topics.length === 0) return;
      container.innerHTML = topics.map(function (t) {
        return `<button type="button" class="merlin-topic-btn" data-query="${escapeHtml(t.query)}">
          ${escapeHtml(t.label)} <span aria-hidden="true">+</span>
        </button>`;
      }).join('');
    }

    function updateReassurance(title, text) {
      const r = document.querySelector('.merlin-reassurance');
      if (!r) return;
      const strong = r.querySelector('strong');
      const p = r.querySelector('p');
      if (strong && title) strong.textContent = title;
      if (p && text) p.textContent = text;
    }

    function openAdvisor(originKind, triggerEl) {
      const els = getElements();
      if (!els.backdrop) return;

      const openingEl = document.querySelector('.merlin-answer-opening');
      if (originKind !== 'cart' && openingEl && openingEl.classList.contains('merlin-cart-intro-card')) {
        openingEl.className = 'merlin-answer-opening';
        openingEl.innerHTML = `
          <h3 id="merlin-dynamic-heading"></h3>
          <p id="merlin-dynamic-intro"></p>
        `;
      }

      // 0. Top Layer / Modal Çakışmasını Çöz:
      // Eğer bir modal çekmece açıksa (özellikle theme-drawer#cart-drawer dialog showModal),
      // tarayıcının Top Layer'ını derhal serbest bırak ki MERLİN öne gelebilsin.
      const activeDrawer = triggerEl?.closest('theme-drawer') || document.querySelector('theme-drawer[open]');
      if (activeDrawer) {
        if (typeof activeDrawer.close === 'function') {
          activeDrawer.close();
        }
        const panel = activeDrawer.querySelector('dialog');
        if (panel && typeof panel.close === 'function' && panel.open) {
          panel.close();
        }
        activeDrawer.removeAttribute('open');
      }

      STATE.isOpen = true;
      STATE.origin = originKind || 'header';
      STATE.productInfo = null;
      STATE.collectionInfo = detectCollectionContext(triggerEl);
      STATE.cartItems = [];

      // 1. Origin'e göre Dinamik Başlık ve Ribbon (Astra Paritesi)
      if (originKind === 'product') {
        const titleEl = document.querySelector('.product-title, h1[data-product-title], .product__title');
        const priceEl = document.querySelector('.price-item--regular, .price__regular .price-item');
        const imgEl = document.querySelector('.product__media img, .product-media img, .media--adapt img');

        const title = triggerEl?.dataset?.productTitle || titleEl?.textContent?.trim() || 'Seçili Lasirius Tasarımı';
        const price = triggerEl?.dataset?.productPrice || priceEl?.textContent?.trim() || '';
        const image = triggerEl?.dataset?.productImage || imgEl?.src || '';
        const url = triggerEl?.dataset?.productUrl || window.location.pathname;
        const productId = triggerEl?.dataset?.productId || document.querySelector('[data-product-id]')?.dataset?.productId || '';
        const variantId = document.querySelector('[data-current-variant-id]')?.dataset?.currentVariantId || triggerEl?.dataset?.variantId || '';

        STATE.productInfo = { id: productId, variantId, title, price, image, url };

        if (els.contextText) els.contextText.textContent = 'Bu ürünün ayrıntılarına birlikte bakalım';
        if (els.dynamicHeading) els.dynamicHeading.textContent = 'Bu tasarımı yakından inceleyelim.';
        if (els.dynamicIntro) {
          els.dynamicIntro.textContent = 'Seçtiğiniz ürünün doğrulanmış ayrıntılarına birlikte bakalım. Bilgi eksikse kesin bir iddia yerine açıkça teyit isteyelim.';
        }
        if (els.followupText) {
          els.followupText.textContent = 'Bu parçanın kalıbı veya bakım detayları hakkında ne düşünüyorsunuz?';
        }

        // Ürün Kartını Render Et (Astra ChoiceCard)
        if (els.productSlot) {
          const safeImage = safeImageUrl(image);
          const safeUrl = safeProductUrl(url);
          els.productSlot.innerHTML = `
            <article class="merlin-choice-card" aria-label="MERLİN ürün önerisi">
              <div class="merlin-choice-main">
                ${safeImage ? `<img src="${escapeHtml(safeImage)}" alt="${escapeHtml(title)}" loading="lazy" decoding="async" />` : ''}
                <div class="merlin-choice-info">
                  <p class="merlin-product-eyebrow">BİRLİKTE KEŞFEDELİM</p>
                  <h3 title="${escapeHtml(title)}">${escapeHtml(title)}</h3>
                  ${price ? `<p class="merlin-product-price">${escapeHtml(price)}</p>` : ''}
                  <small>Varyantları ürün sayfasında inceleyin</small>
                </div>
              </div>
              <div class="merlin-fact-panel">
                <span class="merlin-fact-title">Doğrulanmış ürün bilgisi</span>
                <p>Ürüne özel kumaş, kalıp ve bakım bilgisini yalnız yayımlanmış mağaza kaydından aktarırım.</p>
              </div>
              ${safeUrl ? `<a class="merlin-product-cta" href="${escapeHtml(safeUrl)}">
                <span>Ürünü ve seçenekleri incele</span>
                <span aria-hidden="true">↗</span>
              </a>` : ''}
            </article>
          `;
        }
      } else if (originKind === 'cart') {
        // Sepetteki TÜM ürün bilgilerini adli olarak oku
        const cartRows = document.querySelectorAll('#cart-drawer .cart-items__table-row');
        const cartItems = [];
        cartRows.forEach(function (row) {
          const t = row.querySelector('.cart-items__title')?.textContent?.trim();
          const p = row.querySelector('.cart-items__price')?.textContent?.trim();
          const img = row.querySelector('.cart-items__media img')?.src;
          const v = row.querySelector('.cart-items__variant dd')?.textContent?.trim() ||
                    row.querySelector('.cart-items__variants')?.textContent?.trim() || '';
          const q = row.querySelector('cart-quantity-selector-component input')?.value?.trim() || '1';
          const productId = row.dataset.productId || '';
          const variantId = row.dataset.variantId || '';
          if (t) cartItems.push({ title: t, price: p, img: img, variant: v, qty: q, product_id: productId, variant_id: variantId });
        });
        const totalVal = document.querySelector('#cart-drawer .cart-totals__total-value')?.textContent?.trim() || '';

        STATE.cartItems = cartItems;
        STATE.cartTotal = totalVal;

        const insight = generateCartAdvisorInsight(cartItems, totalVal);

        if (els.contextText) {
          els.contextText.textContent = cartItems.length > 0
            ? 'Sepetinizdeki ' + cartItems.length + ' parça için stil danışmanınız hazır'
            : 'Sepet seçimleriniz için MERLİN';
        }
        const openingEl = document.querySelector('.merlin-answer-opening');
        if (openingEl) {
          openingEl.className = 'merlin-answer-opening merlin-cart-intro-card';
          openingEl.innerHTML = `
            <span class="merlin-cart-intro-eyebrow">
              <span aria-hidden="true">✦</span>
              <span>STİL DANIŞMANI DEĞERLENDİRMESİ</span>
            </span>
            <h3 id="merlin-dynamic-heading" class="merlin-cart-intro-heading">${escapeHtml(insight.heading)}</h3>
            <p id="merlin-dynamic-intro" class="merlin-cart-intro-text">${escapeHtml(insight.intro)}</p>
          `;
        } else {
          if (els.dynamicHeading) els.dynamicHeading.textContent = insight.heading;
          if (els.dynamicIntro) els.dynamicIntro.textContent = insight.intro;
        }
        if (els.followupText) {
          els.followupText.textContent = 'Kombin uyumu, beden teyidi veya teslimat süreci hakkında bilgi ister misiniz?';
        }

        if (els.productSlot && cartItems.length > 0) {
          const cardsHtml = cartItems.map(function (item, idx) {
            const cleanTitle = cleanProductTitle(item.title);
            return `
              <div class="merlin-cart-capsule-card" data-cart-index="${idx}" role="button" tabindex="0" title="${escapeHtml(item.title)}">
                ${safeImageUrl(item.img) ? `<img src="${escapeHtml(safeImageUrl(item.img))}" class="merlin-cart-capsule-thumb" alt="${escapeHtml(item.title)}" loading="lazy" decoding="async" />` : '<span class="merlin-cart-capsule-thumb" style="display:flex;align-items:center;justify-content:center;color:#E0386C;font-size:14px;background:#FFF0F4;">✦</span>'}
                <div class="merlin-cart-capsule-info">
                  <span class="merlin-cart-capsule-title">${escapeHtml(cleanTitle)}</span>
                  <div class="merlin-cart-capsule-meta">
                    ${item.variant ? `<span class="merlin-cart-capsule-variant">${escapeHtml(item.variant)}</span>` : ''}
                    ${item.price ? `<span class="merlin-cart-capsule-price">${escapeHtml(item.price)}</span>` : ''}
                  </div>
                </div>
              </div>
            `;
          }).join('');

          els.productSlot.innerHTML = `
            <div class="merlin-cart-capsule-strip" aria-label="Sepetteki tüm parçalar">
              <div class="merlin-cart-capsule-header">
                <span class="merlin-cart-capsule-eyebrow">
                  <span aria-hidden="true">✦</span>
                  <span>SEPETİNİZDEKİ PARÇALAR (${cartItems.length} ÜRÜN)</span>
                </span>
                ${totalVal ? `<span class="merlin-cart-capsule-total">Toplam: ${escapeHtml(totalVal)}</span>` : ''}
              </div>
              <div class="merlin-cart-capsule-scroll" role="region" aria-label="Sepet ürünleri yatay kaydırma listesi">
                ${cardsHtml}
              </div>
              ${cartItems.length > 1 ? '<span class="merlin-cart-capsule-hint">Diğer parçalar için yana kaydırın →</span>' : ''}
            </div>
          `;
        } else if (els.productSlot) {
          els.productSlot.innerHTML = '';
        }
      } else if (originKind === 'collection' || STATE.collectionInfo) {
        const colTitle = STATE.collectionInfo ? STATE.collectionInfo.title : 'Koleksiyon';
        const colHandle = STATE.collectionInfo ? STATE.collectionInfo.handle : '';
        const colCombined = (colTitle + ' ' + colHandle).toLowerCase();

        const isAvize = /avize|aydınlatma|sarkıt|lamba|aplik/i.test(colCombined);
        const isDecorObject = (/3d|obje|biblo|vazo|tepsi|kalemlik|heykel|tasarım|tasarim|yaşam|yasam|dekor/i.test(colCombined)) && !isAvize;
        const isSuit = /takım|takim|tracksuit/i.test(colCombined);
        const isBottom = (/eşofman alt|esofman alt|pantolon|tayt|jogger|sweatpants/i.test(colCombined)) && !isSuit;
        const isCardigan = /hırka|hirka|triko|kazak/i.test(colCombined);

        if (els.contextText) {
          els.contextText.textContent = colTitle + ' · Danışmanınız hazır';
        }
        if (els.dynamicHeading) {
          els.dynamicHeading.textContent = colTitle + ' Seçkisini Keşfedelim';
        }

        if (els.dynamicIntro) {
          if (isAvize) {
            els.dynamicIntro.textContent = 'Bu koleksiyondaki 3D tasarım ve aydınlatma modellerini, ölçü, montaj ve teknik detayları birlikte değerlendirebiliriz. Aklınızdaki parçayı sormanız yeterli.';
          } else if (isDecorObject) {
            els.dynamicIntro.textContent = 'Bu seçkideki 3D tasarım ve masaüstü dekorasyon objelerini, malzeme kalitesi, ölçü ve yaşam alanı uyumunu birlikte değerlendirebiliriz.';
          } else if (isSuit) {
            els.dynamicIntro.textContent = 'Bu seçkideki ikili takım tasarımları için kalıp, kumaş dokusu ve beden uyumunu birlikte değerlendirebiliriz.';
          } else if (isBottom) {
            els.dynamicIntro.textContent = 'Bu seçkideki alt giyim tasarımları için yayımlanmış kalıp, kumaş esnekliği ve bel/paça detaylarını birlikte değerlendirebiliriz.';
          } else if (isCardigan) {
            els.dynamicIntro.textContent = 'Bu seçkideki triko ve hırka tasarımları için örgü dokusu, omuz dökümü ve bakım detaylarını birlikte değerlendirebiliriz.';
          } else {
            els.dynamicIntro.textContent = 'Bu seçkideki ürünler için yayımlanmış kalıp, kumaş ve bakım bilgilerini birlikte değerlendirebiliriz. Koleksiyondan öneri isteyebilir veya aklınızdaki soruyu sorabilirsiniz.';
          }
        }

        if (els.followupText) {
          els.followupText.textContent = colTitle + ' modelleri arasından size en uygun tasarımı bulalım mı?';
        }
        if (els.productSlot) els.productSlot.innerHTML = '';

        if (isAvize) {
          updateReassurance(
            'Tasarım & Aydınlatma',
            'Ölçü, tavan montajı, ampul ve duy uyumunda tereddüt ettiğiniz noktaları adım adım yanıtlayalım.'
          );
          updateTopicOptions([
            { label: 'Koleksiyon önerisi', query: 'Bu koleksiyondan öne çıkan tasarımları önerir misin?' },
            { label: 'Ölçü & Montaj', query: 'Avize ölçüleri ve tavan montaj detayları nelerdir?' },
            { label: 'Işık & Ampul', query: 'Hangi ampul ve duy tipi ile uyumlu, ışık gücü nasıl?' },
            { label: 'Tasarım tavsiyesi', query: 'Yaşam alanıma uygun aydınlatma tavsiyesi verir misin?' }
          ]);
        } else if (isDecorObject) {
          updateReassurance(
            '3D Tasarım & Yaşam Objesi',
            'Malzeme kalitesi (PLA/baskı), kullanım alanı ve bakımında tereddüt ettiğiniz noktaları adım adım yanıtlayalım.'
          );
          updateTopicOptions([
            { label: 'Obje önerisi', query: 'Bu koleksiyondan öne çıkan dekoratif objeleri önerir misin?' },
            { label: 'Malzeme & Baskı', query: '3D tasarım malzemesi, dayanıklılığı ve temizliği nasıl?' },
            { label: 'Kullanım alanı', query: 'Masaüstü veya sehpa için hangi tasarımlar uygun?' },
            { label: 'Hediye seçimi', query: 'Dekoratif hediye olarak en çok hangileri tercih ediliyor?' }
          ]);
        } else if (isSuit) {
          updateReassurance(
            'Özenli Takım Seçimleri',
            'Üst ve alt parça kalıpları, pamuk dokusu ve mevsimlik kullanımda tereddüt ettiğiniz noktaları yanıtlayalım.'
          );
          updateTopicOptions([
            { label: 'Takım önerisi', query: 'Bu koleksiyondaki öne çıkan takımları önerir misin?' },
            { label: 'Kalıp & Beden', query: 'Üst ve alt parça kalıpları nasıl, tam beden mi alınmalı?' },
            { label: 'Kumaş içeriği', query: 'Kumaş dokusu, pamuk oranı ve mevsimlik kullanımı nasıl?' },
            { label: 'Stil detayları', query: 'Fermuarlı dik yaka ve detaylar hakkında bilgi verir misin?' }
          ]);
        } else if (isBottom) {
          updateReassurance(
            'Alt Giyim & Konfor',
            'Bel yüksekliği, kumaş toparlayıcılığı ve beden uyumunda tereddüt ettiğiniz noktaları adım adım yanıtlayalım.'
          );
          updateTopicOptions([
            { label: 'Model önerisi', query: 'Bu koleksiyondan en çok tercih edilen modelleri önerir misin?' },
            { label: 'Bel & Kalıp', query: 'Yüksek bel formu ve paça kesimi nasıl?' },
            { label: 'Kumaş & Doku', query: 'Kumaş esnekliği, iç gösterme durumu ve dokusu nasıl?' },
            { label: 'Kombin tavsiyesi', query: 'Bu parçayı üst giyimde neyle kombinleyebilirim?' }
          ]);
        } else if (isCardigan) {
          updateReassurance(
            'Triko & Hırka Zarafeti',
            'Örgü dokusu, döküm, tüylenme direnci ve yıkama talimatlarında tereddüt ettiğiniz noktaları adım adım yanıtlayalım.'
          );
          updateTopicOptions([
            { label: 'Hırka önerisi', query: 'Bu koleksiyondaki öne çıkan hırka ve trikoları önerir misin?' },
            { label: 'Örgü & Döküm', query: 'Örgü yapısı kalın mı, omuz dökümü ve boyu nasıl?' },
            { label: 'Yıkama & Bakım', query: 'Triko hırkanın formunu koruması için nasıl yıkanmalı?' },
            { label: 'Stil tavsiyesi', query: 'Bu hırkayı hangi renk ve alt giyim parçalarıyla kombinleyebilirim?' }
          ]);
        } else {
          updateReassurance(
            'Özenli Seçimler',
            'Kumaş dokusu, kalıp ve kombin uyumunda tereddüt ettiğiniz noktaları adım adım yanıtlayalım.'
          );
          updateTopicOptions([
            { label: 'Koleksiyon önerisi', query: 'Bu koleksiyondan öne çıkan parçaları önerir misin?' },
            { label: 'Beden & uyum', query: 'Kalıplar tam beden mi, beden seçiminde neye dikkat edilmeli?' },
            { label: 'Kumaş hakkında', query: 'Bu parçanın kumaş dokusu ve dökümü nasıl?' },
            { label: 'Stil tavsiyesi', query: 'Bu tasarımları neyle kombinleyebilirim?' }
          ]);
        }
      } else if (originKind === 'hero') {
        if (els.contextText) els.contextText.textContent = 'Lasirius Stil & Danışmanlık';
        if (els.dynamicHeading) els.dynamicHeading.textContent = 'Lasirius dünyasına hoş geldiniz.';
        if (els.dynamicIntro) {
          els.dynamicIntro.textContent = 'Doğrulanmış ürün bilgileriyle giyim ve yaşam alanı seçeneklerini birlikte değerlendirelim.';
        }
        if (els.followupText) {
          els.followupText.textContent = 'Giyim koleksiyonları veya ev tasarımı hakkında aklınıza takılan her şeyi sorabilirsiniz.';
        }
        if (els.productSlot) els.productSlot.innerHTML = '';
        updateReassurance('Özenli Seçimler', 'Kumaş dokusu, kalıp ve kombin uyumunda tereddüt ettiğiniz noktaları adım adım yanıtlayalım.');
        updateTopicOptions([
          { label: 'Beden & uyum', query: 'Kumaş dokusu, lif içeriği ve bakım önerileri nedir?' },
          { label: 'Kumaş hakkında', query: 'Bu parçanın kumaş dokusu ve dökümü nasıl?' },
          { label: 'Bakım önerisi', query: 'Bu ürün için en doğru yıkama ve bakım tavsiyesi nedir?' },
          { label: 'Stil tavsiyesi', query: 'Bu tasarımı neyle kombinleyebilirim?' }
        ]);
      } else if (originKind === 'slider_new_arrivals') {
        if (els.contextText) els.contextText.textContent = 'Yeni gelen parçalar';
        if (els.dynamicHeading) els.dynamicHeading.textContent = 'Yeni gelenleri birlikte keşfedelim.';
        if (els.dynamicIntro) {
          els.dynamicIntro.textContent = 'Yeni ürünlerin yayımlanmış ayrıntılarını ve seçeneklerini birlikte inceleyebiliriz.';
        }
        if (els.followupText) {
          els.followupText.textContent = 'Hangi yeni tasarım hakkında bilgi almak istersiniz?';
        }
        if (els.productSlot) els.productSlot.innerHTML = '';
        updateReassurance('Özenli Seçimler', 'Kumaş dokusu, kalıp ve kombin uyumunda tereddüt ettiğiniz noktaları adım adım yanıtlayalım.');
        updateTopicOptions([
          { label: 'Beden & uyum', query: 'Kumaş dokusu, lif içeriği ve bakım önerileri nedir?' },
          { label: 'Kumaş hakkında', query: 'Bu parçanın kumaş dokusu ve dökümü nasıl?' },
          { label: 'Bakım önerisi', query: 'Bu ürün için en doğru yıkama ve bakım tavsiyesi nedir?' },
          { label: 'Stil tavsiyesi', query: 'Bu tasarımı neyle kombinleyebilirim?' }
        ]);
      } else if (originKind === 'slider_favorites') {
        if (els.contextText) els.contextText.textContent = 'Lasirius favorileri';
        if (els.dynamicHeading) els.dynamicHeading.textContent = 'En çok sevilen favori parçalar.';
        if (els.dynamicIntro) {
          els.dynamicIntro.textContent = 'Öne çıkan ürünlerin doğrulanmış ayrıntılarını birlikte değerlendirelim.';
        }
        if (els.followupText) {
          els.followupText.textContent = 'Öne çıkan bu parçalar arasından size en uygun olanı bulalım mı?';
        }
        if (els.productSlot) els.productSlot.innerHTML = '';
        updateReassurance('Özenli Seçimler', 'Kumaş dokusu, kalıp ve kombin uyumunda tereddüt ettiğiniz noktaları adım adım yanıtlayalım.');
        updateTopicOptions([
          { label: 'Beden & uyum', query: 'Kumaş dokusu, lif içeriği ve bakım önerileri nedir?' },
          { label: 'Kumaş hakkında', query: 'Bu parçanın kumaş dokusu ve dökümü nasıl?' },
          { label: 'Bakım önerisi', query: 'Bu ürün için en doğru yıkama ve bakım tavsiyesi nedir?' },
          { label: 'Stil tavsiyesi', query: 'Bu tasarımı neyle kombinleyebilirim?' }
        ]);
      } else if (originKind === 'homepage_strip') {
        if (els.contextText) els.contextText.textContent = 'Kişisel alışveriş rehberiniz';
        if (els.dynamicHeading) els.dynamicHeading.textContent = 'Zevkinize en uygun parçayı bulalım.';
        if (els.dynamicIntro) {
          els.dynamicIntro.textContent = 'Lasirius koleksiyonlarında aradığınız formu, kumaş dokusunu veya hediye önerilerini birlikte netleştirelim.';
        }
        if (els.followupText) {
          els.followupText.textContent = 'Hangi parça veya koleksiyon hakkında detay istersiniz?';
        }
        if (els.productSlot) els.productSlot.innerHTML = '';
        updateReassurance('Özenli Seçimler', 'Kumaş dokusu, kalıp ve kombin uyumunda tereddüt ettiğiniz noktaları adım adım yanıtlayalım.');
        updateTopicOptions([
          { label: 'Beden & uyum', query: 'Kumaş dokusu, lif içeriği ve bakım önerileri nedir?' },
          { label: 'Kumaş hakkında', query: 'Bu parçanın kumaş dokusu ve dökümü nasıl?' },
          { label: 'Bakım önerisi', query: 'Bu ürün için en doğru yıkama ve bakım tavsiyesi nedir?' },
          { label: 'Stil tavsiyesi', query: 'Bu tasarımı neyle kombinleyebilirim?' }
        ]);
      } else {
        if (els.contextText) els.contextText.textContent = 'İçinize sinen bir seçim için';
        if (els.dynamicHeading) els.dynamicHeading.textContent = 'Merhaba, ben MERLİN.';
        if (els.dynamicIntro) {
          els.dynamicIntro.textContent = 'Ürüne uygun bedeni ve yayımlanmış kumaş bilgisini birlikte değerlendirelim. Aklınızdakini sormanız yeterli.';
        }
        if (els.followupText) {
          els.followupText.textContent = 'Merak ettiğiniz bir parçayı veya detayı paylaşın, hemen başlayalım.';
        }
        if (els.productSlot) els.productSlot.innerHTML = '';
        updateReassurance('Özenli Seçimler', 'Kumaş dokusu, kalıp ve kombin uyumunda tereddüt ettiğiniz noktaları adım adım yanıtlayalım.');
        updateTopicOptions([
          { label: 'Beden & uyum', query: 'Kumaş dokusu, lif içeriği ve bakım önerileri nedir?' },
          { label: 'Kumaş hakkında', query: 'Bu parçanın kumaş dokusu ve dökümü nasıl?' },
          { label: 'Bakım önerisi', query: 'Bu ürün için en doğru yıkama ve bakım tavsiyesi nedir?' },
          { label: 'Stil tavsiyesi', query: 'Bu tasarımı neyle kombinleyebilirim?' }
        ]);
      }

      els.backdrop.classList.add('is-active');
      document.body.style.overflow = 'hidden';

      // Sadece masaüstü cihazlarda (fiziksel klavyeli) otomatik odaklan
      // Mobil cihazlarda klavyenin zıplamasını, kaba açılışı ve ekran kesilmesini önle
      const isDesktop = window.matchMedia('(hover: hover) and (pointer: fine)').matches && window.innerWidth > 768;
      if (isDesktop) {
        setTimeout(function () {
          els.input?.focus();
        }, 320);
      }
    }

    function closeAdvisor() {
      const els = getElements();
      if (!els.backdrop) return;

      if (document.activeElement && (document.activeElement === els.input || els.form?.contains(document.activeElement))) {
        document.activeElement.blur();
      }

      STATE.isOpen = false;
      els.backdrop.classList.remove('is-active');
      document.body.style.overflow = '';
    }

    function appendUserMessage(text) {
      const els = getElements();
      if (!els.streamArea) return;

      const bubble = document.createElement('div');
      bubble.className = 'merlin-question-bubble';
      bubble.innerHTML = `
        <span class="merlin-question-label">SİZ</span>
        <p>${escapeHtml(text)}</p>
      `;

      els.streamArea.appendChild(bubble);
      scrollToBottom();
    }

    const API = {
      baseUrl: (window.location.hostname === 'lasirius.com' || window.location.hostname.endsWith('myshopify.com'))
        ? 'https://tim.lasirius.com'
        : '',
      sessionId: null,
      csrfToken: null,
      orderGrantToken: null,

      async getOrCreateSession() {
        if (this.sessionId && this.csrfToken) return true;
        try {
          const ctrl = new AbortController();
          const timer = setTimeout(() => ctrl.abort(), 3500);
          const res = await fetch(this.baseUrl + '/customer/v1/session', {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
            },
            credentials: 'include',
            signal: ctrl.signal,
          });
          clearTimeout(timer);
          if (res.ok) {
            const data = await res.json();
            this.sessionId = data.session_id;
            this.csrfToken = data.csrf_token;
            return true;
          }
        } catch (e) {
          console.warn('[MERLİN] Session init offline/fallback:', e);
        }
        return false;
      },

      async verifyOrder(orderReference, emailOrPhone) {
        const hasSession = await this.getOrCreateSession();
        if (!hasSession) return null;
        try {
          const res = await fetch(this.baseUrl + '/customer/v1/order/verify', {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'X-CSRF-Token': this.csrfToken,
            },
            credentials: 'include',
            body: JSON.stringify({
              order_reference: orderReference,
              email_or_phone: emailOrPhone,
            }),
          });
          if (res.ok) {
            const data = await res.json();
            if (data.grant_token) {
              this.orderGrantToken = data.grant_token;
            }
            return data;
          }
          return { error: true, detail: 'ORDER_VERIFICATION_FAILED' };
        } catch (e) {
          console.warn('[MERLİN] Order verify network error:', e);
          return { error: true, detail: 'NETWORK_ERROR' };
        }
      },

      async sendMessage(message, productId, variantId, cartItems, collectionContext) {
        const hasSession = await this.getOrCreateSession();
        if (!hasSession) return null;
        try {
          const ctrl = new AbortController();
          const timer = setTimeout(() => ctrl.abort(), 8000);
          const headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-CSRF-Token': this.csrfToken,
          };
          if (this.orderGrantToken) {
            headers['X-Order-Grant'] = this.orderGrantToken;
          }
          const res = await fetch(this.baseUrl + '/customer/v1/message', {
            method: 'POST',
            headers: headers,
            credentials: 'include',
            signal: ctrl.signal,
            body: JSON.stringify({
              message: message,
              client_message_id: createClientMessageId(),
              current_product_id: productId || null,
              current_variant_id: variantId || null,
              current_collection_id: collectionContext?.id ? String(collectionContext.id) : null,
              collection_handle: collectionContext?.handle || null,
              collection_title: collectionContext?.title || null,
              collection_product_ids: Array.isArray(collectionContext?.product_ids) ? collectionContext.product_ids : [],
              cart_items: cartItems || [],
              cart_product_ids: [],
              order_grant_token: this.orderGrantToken || null,
            }),
          });
          clearTimeout(timer);
          if (res.ok) {
            return await res.json();
          }
        } catch (e) {
          console.warn('[MERLİN] Message API offline/fallback:', e);
        }
        return null;
      },

      async streamMessage(message, productId, variantId, cartItems, collectionContext, callbacks) {
        const hasSession = await this.getOrCreateSession();
        if (!hasSession) return false;
        try {
          const headers = {
            'Accept': 'text/event-stream',
            'Content-Type': 'application/json',
            'X-CSRF-Token': this.csrfToken,
          };
          if (this.orderGrantToken) {
            headers['X-Order-Grant'] = this.orderGrantToken;
          }
          const res = await fetch(this.baseUrl + '/customer/v1/message/stream', {
            method: 'POST',
            headers: headers,
            credentials: 'include',
            body: JSON.stringify({
              message: message,
              client_message_id: createClientMessageId(),
              current_product_id: productId || null,
              current_variant_id: variantId || null,
              current_collection_id: collectionContext?.id ? String(collectionContext.id) : null,
              collection_handle: collectionContext?.handle || null,
              collection_title: collectionContext?.title || null,
              collection_product_ids: Array.isArray(collectionContext?.product_ids) ? collectionContext.product_ids : [],
              cart_items: cartItems || [],
              cart_product_ids: [],
              order_grant_token: this.orderGrantToken || null,
            }),
          });
          if (!res.ok || !res.body) {
            return false;
          }
          const reader = res.body.getReader();
          const decoder = new TextDecoder('utf-8');
          let buffer = '';
          let currentEvent = 'message';

          while (true) {
            const { done, value } = await reader.read();
            if (done) break;
            buffer += decoder.decode(value, { stream: true });
            const lines = buffer.split('\n');
            buffer = lines.pop() || '';

            for (const line of lines) {
              const trimmed = line.trim();
              if (!trimmed) {
                currentEvent = 'message';
                continue;
              }
              if (trimmed.startsWith('event: ')) {
                currentEvent = trimmed.slice(7).trim();
              } else if (trimmed.startsWith('data: ')) {
                const dataRaw = trimmed.slice(6).trim();
                try {
                  const data = JSON.parse(dataRaw);
                  if (currentEvent === 'status' && callbacks.onStatus) {
                    callbacks.onStatus(data);
                  } else if (currentEvent === 'product_cards' && callbacks.onCards) {
                    callbacks.onCards(data.cards || []);
                  } else if (currentEvent === 'order_evidence' && callbacks.onOrderEvidence) {
                    callbacks.onOrderEvidence(data);
                  } else if (currentEvent === 'text_delta' && callbacks.onTextDelta) {
                    callbacks.onTextDelta(data.delta || '');
                  } else if (currentEvent === 'followup' && callbacks.onFollowup) {
                    callbacks.onFollowup(data.question || '');
                  } else if (currentEvent === 'done' && callbacks.onDone) {
                    callbacks.onDone(data);
                  }
                } catch (_) {}
              }
            }
          }
          return true;
        } catch (e) {
          console.warn('[MERLİN] SSE stream error, falling back:', e);
          return false;
        }
      },
    };

    function renderProductCardsHtml(cards, facts) {
      if (!cards || cards.length === 0) return '';
      return cards.map(function (card) {
        const cleanTitle = cleanProductTitle(card.title);
        const priceFormatted = (card.price_minor / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TL';
        const url = safeProductUrl(card.product_url) || (card.product_url ? card.product_url : '#');
        const img = safeImageUrl(card.image_url);
        const cardFacts = (cards.length === 1 && facts && facts.length > 0) ? facts.slice(0, 3) : [];
        const factsBlock = cardFacts.length > 0 ? `
          <div class="merlin-fact-panel">
            <span class="merlin-fact-title">Öne çıkan detaylar</span>
            <ul>
              ${cardFacts.map(function (f) {
                return '<li><span aria-hidden="true">✓</span><span>' + escapeHtml(f) + '</span></li>';
              }).join('')}
            </ul>
          </div>
        ` : '';

        return `
          <article class="merlin-choice-card" aria-label="MERLİN ürün önerisi">
            <div class="merlin-choice-main">
              ${img ? `<img src="${escapeHtml(img)}" alt="${escapeHtml(cleanTitle)}" width="112" height="150" loading="lazy" decoding="async" />` : '<div style="width:112px;height:150px;background:#f7f3f5;border-radius:11px;display:flex;align-items:center;justify-content:center;color:#b3728f;font-size:24px;">✦</div>'}
              <div class="merlin-choice-info">
                <p class="merlin-product-eyebrow">BİRLİKTE KEŞFEDELİM</p>
                <h3 title="${escapeHtml(card.title)}">${escapeHtml(cleanTitle)}</h3>
                <p class="merlin-product-price">${priceFormatted}</p>
                <small>Varyantları ürün sayfasında inceleyin</small>
              </div>
            </div>
            ${factsBlock}
            ${url && url !== '#' ? `<a class="merlin-product-cta" href="${escapeHtml(url)}" target="_blank" rel="noopener noreferrer">Ürünü ve seçenekleri incele <span aria-hidden="true">↗</span></a>` : ''}
          </article>
        `;
      }).join('');
    }

    function renderOrderEvidenceHtml(evidence) {
      if (!evidence) return '';
      const orderName = escapeHtml(evidence.order_name || '');
      const statusDisplay = escapeHtml(evidence.overall_status_display || 'Durum Belirtilmedi');
      const city = evidence.destination_city ? ` · Teslimat: ${escapeHtml(evidence.destination_city)}` : '';
      const overallStatus = evidence.overall_status || '';
      const isDelivered = overallStatus === 'DELIVERED';
      const isTransit = overallStatus === 'IN_TRANSIT' || overallStatus === 'HANDED_TO_CARRIER';
      const badgeClass = isDelivered ? 'is-delivered' : isTransit ? 'is-transit' : '';

      let packagesHtml = '';
      if (evidence.packages && evidence.packages.length > 0) {
        packagesHtml = evidence.packages.map(function (pkg, idx) {
          const pkgTitle = evidence.packages.length > 1 ? `Paket ${pkg.package_number || idx + 1}` : 'Gönderi Detayı';
          const carrier = escapeHtml(pkg.carrier_name || 'Kargo Firması');
          const status = escapeHtml(pkg.status_display || '');
          const trackingMasked = pkg.tracking_number_masked ? `<span class="merlin-order-tracking-number">Takip: ${escapeHtml(pkg.tracking_number_masked)}</span>` : '';
          const trackCta = pkg.tracking_url ? `<a href="${escapeHtml(pkg.tracking_url)}" target="_blank" rel="noopener noreferrer" class="merlin-order-track-cta">Kargoyu Takip Et ↗</a>` : '';

          let itemsHtml = '';
          if (pkg.items_summary && pkg.items_summary.length > 0) {
            itemsHtml = `
              <div class="merlin-order-package-items">
                <ul>
                  ${pkg.items_summary.map(function (item) { return `<li>${escapeHtml(item)}</li>`; }).join('')}
                </ul>
              </div>
            `;
          }

          return `
            <div class="merlin-order-package-item">
              <div class="merlin-order-package-header">
                <span class="merlin-order-package-title">${escapeHtml(pkgTitle)}</span>
                <span class="merlin-order-package-carrier">${carrier} · ${status}</span>
              </div>
              ${itemsHtml}
              ${(trackingMasked || trackCta) ? `
                <div class="merlin-order-package-footer">
                  ${trackingMasked}
                  ${trackCta}
                </div>
              ` : ''}
            </div>
          `;
        }).join('');
      }

      return `
        <div class="merlin-order-evidence-card">
          <div class="merlin-order-evidence-top">
            <div class="merlin-order-ref-group">
              <span class="merlin-order-number">${orderName}</span>
              <span class="merlin-order-city">${city}</span>
            </div>
            <span class="merlin-order-badge ${badgeClass}">${statusDisplay}</span>
          </div>
          <div class="merlin-order-packages-list">
            ${packagesHtml}
          </div>
        </div>
      `;
    }

    function renderOrderVerificationCardHtml() {
      return `
        <div class="merlin-order-verify-card">
          <div class="merlin-order-verify-header">
            <span class="merlin-order-verify-icon">📦</span>
            <span class="merlin-order-verify-title">Siparişinizi Doğrulayın</span>
          </div>
          <p class="merlin-order-verify-desc">Sipariş ve kargo durumunuzu güvenle görüntülemek için lütfen sipariş numaranızı ve siparişte kullandığınız e-posta veya telefon numaranızı girin.</p>
          <form class="merlin-order-verify-form" onsubmit="return false;">
            <div class="merlin-order-verify-inputs">
              <input type="text" class="merlin-order-input merlin-verify-order-ref" placeholder="Sipariş No (örn: #1002)" required />
              <input type="text" class="merlin-order-input merlin-verify-contact" placeholder="E-posta veya Telefon" required />
            </div>
            <button type="button" class="merlin-order-verify-submit">
              <span>Siparişimi Sorgula</span> ➔
            </button>
            <div class="merlin-order-verify-error">Sipariş numarası veya iletişim bilgisi eşleşmedi. Lütfen bilgilerinizi kontrol edin.</div>
          </form>
        </div>
      `;
    }

    function attachOrderVerificationHandler(container) {
      if (!container) return;
      const verifyCard = container.querySelector('.merlin-order-verify-card');
      if (!verifyCard) return;

      const submitBtn = verifyCard.querySelector('.merlin-order-verify-submit');
      const refInput = verifyCard.querySelector('.merlin-verify-order-ref');
      const contactInput = verifyCard.querySelector('.merlin-verify-contact');
      const errEl = verifyCard.querySelector('.merlin-order-verify-error');

      if (!submitBtn || !refInput || !contactInput) return;

      submitBtn.addEventListener('click', async function () {
        const orderRef = refInput.value.trim();
        const contact = contactInput.value.trim();
        if (!orderRef || !contact) {
          if (errEl) {
            errEl.textContent = 'Lütfen sipariş numarası ve iletişim bilgisini girin.';
            errEl.style.display = 'block';
          }
          return;
        }

        submitBtn.disabled = true;
        submitBtn.innerHTML = '<span>Kontrol ediliyor…</span>';
        if (errEl) errEl.style.display = 'none';

        const result = await API.verifyOrder(orderRef, contact);
        if (result && result.success && result.evidence) {
          verifyCard.outerHTML = renderOrderEvidenceHtml(result.evidence);
          scrollToBottom(true);
          handleQuestion(`${result.order_name || orderRef} siparişimin kargo durumunu açıklar mısın?`);
        } else {
          submitBtn.disabled = false;
          submitBtn.innerHTML = '<span>Siparişimi Sorgula</span> ➔';
          if (errEl) {
            errEl.textContent = 'Sipariş numarası veya iletişim bilgisi eşleşmedi. Lütfen kontrol edip tekrar deneyin.';
            errEl.style.display = 'block';
          }
        }
      });
    }

    function appendBotAnswer(heading, intro, facts, followupQuestion, handoff, cards, orderAction, orderEvidence) {
      const els = getElements();
      if (!els.streamArea) return;

      const article = document.createElement('article');
      article.className = 'merlin-answer-article';

      let cardsHtml = '';
      if (orderAction === 'VERIFICATION_REQUIRED') {
        cardsHtml = renderOrderVerificationCardHtml();
      } else if (orderEvidence) {
        cardsHtml = renderOrderEvidenceHtml(orderEvidence);
      } else {
        cardsHtml = renderProductCardsHtml(cards, facts);
      }

      let factsHtml = '';
      if (facts && facts.length > 0 && (!cards || cards.length !== 1)) {
        factsHtml = `
          <div class="merlin-reassurance" style="margin: 12px 0;">
            <span class="merlin-reassurance-icon" aria-hidden="true">✦</span>
            <div>
              <strong>Önemli Detaylar</strong>
              <p>${facts.map(escapeHtml).join(' · ')}</p>
            </div>
          </div>
        `;
      }

      let handoffHtml = '';
      if (handoff) {
        handoffHtml = `
          <div class="merlin-handoff-card" style="margin: 14px 0; padding: 12px 14px; background: rgba(37, 211, 102, 0.08); border: 1px solid rgba(37, 211, 102, 0.25); border-radius: 8px; display: flex; align-items: center; justify-content: space-between; gap: 10px;">
            <div style="font-size: 13px; color: #111827;">
              <strong>Birebir Danışman Desteği</strong>
              <div style="font-size: 12px; color: #4b5563; margin-top: 2px;">Dilerseniz stilistimize doğrudan WhatsApp üzerinden ulaşabilirsiniz.</div>
            </div>
            <a href="https://wa.me/905071204819?text=Merhaba%2C%20Lasirius%20dan%C4%B1%C5%9Fman%C4%B1ndan%20yaz%C4%B1yorum." target="_blank" rel="noopener noreferrer" style="white-space: nowrap; display: inline-flex; align-items: center; gap: 6px; padding: 7px 12px; background: #25D366; color: #fff; font-size: 12px; font-weight: 600; border-radius: 6px; text-decoration: none;">
              WhatsApp ↗
            </a>
          </div>
        `;
      }

      const followupHtml = followupQuestion ? `
        <p class="merlin-followup">
          <span aria-hidden="true">↳</span>
          <span>${escapeHtml(followupQuestion)}</span>
        </p>
      ` : '';

      const headingHtml = heading && heading.trim() ? `<h3>${escapeHtml(heading.trim())}</h3>` : '';
      const introHtml = intro && intro.trim()
        ? `<div class="merlin-live-intro merlin-prose-content">${renderSafeMarkdown(intro, false)}</div>`
        : '';

      article.innerHTML = `
        <div class="merlin-answer-signature">
          <span aria-hidden="true">✦</span> MERLİN
        </div>
        <div class="merlin-answer-opening">
          ${headingHtml}
          ${introHtml}
        </div>
        ${cardsHtml}
        ${factsHtml}
        ${handoffHtml}
        ${followupHtml}
      `;

      els.streamArea.appendChild(article);
      if (orderAction === 'VERIFICATION_REQUIRED') {
        attachOrderVerificationHandler(article);
      }
      scrollToBottom(true);
    }

    async function handleQuestion(question) {
      if (!question || !question.trim()) return;
      const clean = question.trim();

      appendUserMessage(clean);

      const els = getElements();
      if (els.input) els.input.value = '';

      const currentPid = STATE.productInfo ? String(STATE.productInfo.id || '') : null;
      const currentVariantId = STATE.productInfo ? String(STATE.productInfo.variantId || '') : null;
      const collectionContext = STATE.collectionInfo ? {
        id: STATE.collectionInfo.id || '',
        handle: STATE.collectionInfo.handle || '',
        title: STATE.collectionInfo.title || '',
        product_ids: Array.isArray(STATE.collectionInfo.product_ids) ? STATE.collectionInfo.product_ids : [],
      } : null;
      const cartItems = STATE.cartItems
        ? STATE.cartItems
            .filter((item) => item.product_id)
            .map((item) => ({
              product_id: String(item.product_id),
              variant_id: item.variant_id ? String(item.variant_id) : null,
            }))
        : [];

      // Canlı SSE Streaming makalesi oluştur
      const liveArticle = document.createElement('article');
      liveArticle.className = 'merlin-answer-article merlin-streaming-active';
      liveArticle.innerHTML = `
        <div class="merlin-answer-signature">
          <span aria-hidden="true">✦</span> MERLİN
          <span class="merlin-stream-status" style="font-size: 11px; color: #b3728f; margin-left: 8px; font-weight: normal;">düşünüyor…</span>
        </div>
        <div class="merlin-answer-opening">
          <h3 class="merlin-live-heading" style="display:none; margin-bottom: 6px;"></h3>
          <div class="merlin-live-intro merlin-prose-content"></div>
        </div>
        <div class="merlin-live-cards"></div>
        <div class="merlin-live-facts"></div>
        <div class="merlin-live-handoff"></div>
        <p class="merlin-followup" style="display:none;">
          <span aria-hidden="true">↳</span>
          <span class="merlin-live-followup"></span>
        </p>
      `;
      els.streamArea.appendChild(liveArticle);
      scrollToBottom(true);

      const headingEl = liveArticle.querySelector('.merlin-live-heading');
      const introEl = liveArticle.querySelector('.merlin-live-intro');
      const cardsEl = liveArticle.querySelector('.merlin-live-cards');
      const factsEl = liveArticle.querySelector('.merlin-live-facts');
      const handoffEl = liveArticle.querySelector('.merlin-live-handoff');
      const followupP = liveArticle.querySelector('.merlin-followup');
      const followupTextEl = liveArticle.querySelector('.merlin-live-followup');
      const statusEl = liveArticle.querySelector('.merlin-stream-status');

      let streamFinished = false;
      let textDeltaReceived = false;
      let introBuffer = '';

      const streamedOk = await API.streamMessage(clean, currentPid, currentVariantId, cartItems, collectionContext, {
        onStatus: function (statusData) {
          if (statusEl && !textDeltaReceived) {
            const st = (statusData && statusData.status) || '';
            if (st === 'order_verification_required') {
              statusEl.textContent = 'doğrulama hazırlanıyor…';
            } else if (st === 'reading_order_status') {
              statusEl.textContent = 'kargo durumu kontrol ediliyor…';
            } else {
              statusEl.textContent = 'katalog inceleniyor…';
            }
          }
        },
        onCards: function (cards) {
          if (cardsEl && cards && cards.length > 0) {
            cardsEl.innerHTML = renderProductCardsHtml(cards, []);
            scrollToBottom();
          }
        },
        onOrderEvidence: function (evidence) {
          if (cardsEl && evidence) {
            cardsEl.innerHTML = renderOrderEvidenceHtml(evidence);
            scrollToBottom();
          }
        },
        onTextDelta: function (delta) {
          textDeltaReceived = true;
          if (statusEl) statusEl.remove();
          introBuffer += delta;
          if (introEl) {
            introEl.innerHTML = renderSafeMarkdown(introBuffer, true);
            scrollToBottom();
          }
        },
        onFollowup: function (qText) {
          if (followupP && followupTextEl && qText) {
            followupTextEl.textContent = qText;
            followupP.style.display = '';
            scrollToBottom();
          }
        },
        onDone: function (doneData) {
          streamFinished = true;
          liveArticle.classList.remove('merlin-streaming-active');
          if (statusEl) statusEl.remove();

          const pres = doneData.presentation || {};
          if (headingEl && pres.heading && pres.heading.trim()) {
            headingEl.textContent = pres.heading.trim();
            headingEl.style.display = '';
          } else if (headingEl) {
            headingEl.style.display = 'none';
          }
          if (introEl) {
            const finalIntro = (pres.intro && pres.intro.trim()) ? pres.intro : introBuffer;
            if (finalIntro) {
              introEl.innerHTML = renderSafeMarkdown(finalIntro, false);
            }
          }
          if (doneData.order_action === 'VERIFICATION_REQUIRED') {
            if (cardsEl) {
              cardsEl.innerHTML = renderOrderVerificationCardHtml();
              attachOrderVerificationHandler(cardsEl);
            }
          } else if (doneData.order_evidence) {
            if (cardsEl) {
              cardsEl.innerHTML = renderOrderEvidenceHtml(doneData.order_evidence);
            }
          } else if (cardsEl && (!cardsEl.innerHTML || !cardsEl.innerHTML.trim()) && doneData.cards && doneData.cards.length > 0) {
            cardsEl.innerHTML = renderProductCardsHtml(doneData.cards, doneData.facts || []);
          }
          if (factsEl && doneData.facts && doneData.facts.length > 0 && (!doneData.cards || doneData.cards.length !== 1)) {
            factsEl.innerHTML = `
              <div class="merlin-reassurance" style="margin: 12px 0;">
                <span class="merlin-reassurance-icon" aria-hidden="true">✦</span>
                <div>
                  <strong>Önemli Detaylar</strong>
                  <p>${doneData.facts.map(escapeHtml).join(' · ')}</p>
                </div>
              </div>
            `;
          }
          if (handoffEl && doneData.handoff) {
            handoffEl.innerHTML = `
              <div class="merlin-handoff-card" style="margin: 14px 0; padding: 12px 14px; background: rgba(37, 211, 102, 0.08); border: 1px solid rgba(37, 211, 102, 0.25); border-radius: 8px; display: flex; align-items: center; justify-content: space-between; gap: 10px;">
                <div style="font-size: 13px; color: #111827;">
                  <strong>Birebir Danışman Desteği</strong>
                  <div style="font-size: 12px; color: #4b5563; margin-top: 2px;">Dilerseniz stilistimize doğrudan WhatsApp üzerinden ulaşabilirsiniz.</div>
                </div>
                <a href="https://wa.me/905071204819?text=Merhaba%2C%20Lasirius%20dan%C4%B1%C5%9Fman%C4%B1ndan%20yaz%C4%B1yorum." target="_blank" rel="noopener noreferrer" style="white-space: nowrap; display: inline-flex; align-items: center; gap: 6px; padding: 7px 12px; background: #25D366; color: #fff; font-size: 12px; font-weight: 600; border-radius: 6px; text-decoration: none;">
                  WhatsApp ↗
                </a>
              </div>
            `;
          }
          if (doneData.question && followupP && followupTextEl) {
            followupTextEl.textContent = doneData.question;
            followupP.style.display = '';
          } else if (!doneData.question && followupP) {
            followupP.style.display = 'none';
          }
          scrollToBottom(true);
        },
      });

      if (!streamedOk || !streamFinished) {
        liveArticle.remove();
        let apiResponse = null;
        try {
          apiResponse = await API.sendMessage(clean, currentPid, currentVariantId, cartItems, collectionContext);
        } catch (err) {
          console.warn('[MERLİN] Live API error, using safe fallback:', err);
        }

        if (apiResponse && apiResponse.presentation) {
          const pres = apiResponse.presentation;
          const heading = pres.heading || 'Tasarım ve kalıp dengesi.';
          const intro = pres.intro || 'Tasarım detaylarını sizin için derledik.';
          const facts = apiResponse.facts || [];
          const questionText = apiResponse.question || null;
          const handoff = Boolean(apiResponse.handoff);
          const cards = apiResponse.cards || [];
          appendBotAnswer(heading, intro, facts, questionText, handoff, cards, apiResponse.order_action, apiResponse.order_evidence);
          return;
        }

        appendBotAnswer(
          'Şu an doğrulanmış yanıtı hazırlayamıyorum.',
          'Mağaza ve sepetiniz çalışmaya devam ediyor. Ürüne özel bilgi için biraz sonra yeniden deneyebilir veya WhatsApp danışmanımıza yazabilirsiniz.',
          [],
          null,
          true,
          []
        );
      }
    }

    function scrollToBottom() {
      const els = getElements();
      if (els.scrollArea) {
        setTimeout(function () {
          els.scrollArea.scrollTop = els.scrollArea.scrollHeight;
        }, 50);
      }
    }

    function escapeHtml(str) {
      return String(str ?? '').replace(/[&<>"']/g, function (char) {
        return {
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#39;',
        }[char];
      });
    }

    function renderSafeInline(rawText, isStreaming) {
      if (!rawText) return '';
      let text = rawText;

      if (isStreaming) {
        text = text.replace(/(\*{1,2}|_{1,2})$/, '');
      }

      let escaped = escapeHtml(text);

      const boldSegments = escaped.split('**');
      if (boldSegments.length > 1) {
        let reconstructed = '';
        for (let i = 0; i < boldSegments.length; i++) {
          if (i % 2 === 0) {
            reconstructed += boldSegments[i];
          } else {
            if (i === boldSegments.length - 1 && isStreaming && boldSegments.length % 2 === 0) {
              reconstructed += '<strong>' + boldSegments[i] + '</strong>';
            } else if (i < boldSegments.length - 1 || boldSegments.length % 2 === 1) {
              reconstructed += '<strong>' + boldSegments[i] + '</strong>';
            } else {
              reconstructed += boldSegments[i];
            }
          }
        }
        escaped = reconstructed;
      }

      escaped = escaped.replace(/(?<=^|[^*])\*([^*]+)\*(?=[^*]|$)/g, '<em>$1</em>');
      escaped = escaped.replace(/(?<=^|[^_])_([^_]+)_(?=[^_]|$)/g, '<em>$1</em>');

      return escaped;
    }

    function renderSafeMarkdown(rawText, isStreaming) {
      if (!rawText) return '';
      const lines = rawText.split('\n');
      const blocks = [];
      let currentList = null;
      let currentParagraph = [];

      function flushParagraph() {
        if (currentParagraph.length > 0) {
          const content = currentParagraph
            .map(function (line) { return renderSafeInline(line, isStreaming); })
            .join('<br>');
          if (content.trim()) {
            blocks.push('<p class="merlin-prose-p">' + content + '</p>');
          }
          currentParagraph = [];
        }
      }

      function flushList() {
        if (currentList) {
          const tag = currentList.type;
          const cls = tag === 'ul' ? 'merlin-bullet-list' : 'merlin-num-list';
          const itemsHtml = currentList.items
            .map(function (item) { return '<li>' + renderSafeInline(item, isStreaming) + '</li>'; })
            .join('');
          blocks.push('<' + tag + ' class="' + cls + '">' + itemsHtml + '</' + tag + '>');
          currentList = null;
        }
      }

      for (let i = 0; i < lines.length; i++) {
        const line = lines[i];
        const trimmed = line.trim();

        if (!trimmed) {
          flushParagraph();
          flushList();
          continue;
        }

        const bulletMatch = line.match(/^(\s*)([•\-\*✦]|\d+\.)\s+(.*)$/);
        if (bulletMatch) {
          flushParagraph();
          const marker = bulletMatch[2];
          const itemContent = bulletMatch[3];
          const isNum = /^\d+\.$/.test(marker);
          const listType = isNum ? 'ol' : 'ul';

          if (!currentList || currentList.type !== listType) {
            flushList();
            currentList = { type: listType, items: [] };
          }
          currentList.items.push(itemContent);
          continue;
        }

        flushList();
        currentParagraph.push(line);
      }

      flushParagraph();
      flushList();

      return blocks.join('');
    }

    function createClientMessageId() {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return window.crypto.randomUUID();
      }
      const bytes = new Uint8Array(16);
      window.crypto.getRandomValues(bytes);
      bytes[6] = (bytes[6] & 0x0f) | 0x40;
      bytes[8] = (bytes[8] & 0x3f) | 0x80;
      const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
      return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
    }

    function safeImageUrl(value) {
      if (!value) return '';
      try {
        const url = new URL(value, window.location.origin);
        if (url.protocol !== 'https:') return '';
        if (url.hostname !== window.location.hostname && url.hostname !== 'cdn.shopify.com') return '';
        return url.href;
      } catch (_) {
        return '';
      }
    }

    function safeProductUrl(value) {
      if (!value) return '';
      try {
        const url = new URL(value, window.location.origin);
        if (url.origin !== window.location.origin || !url.pathname.startsWith('/products/')) return '';
        return url.pathname + url.search;
      } catch (_) {
        return '';
      }
    }

    // Delegated Global Events
    document.addEventListener('click', function (event) {
      const trigger = event.target.closest('[data-merlin-trigger]');
      if (trigger) {
        event.preventDefault();
        const origin = trigger.getAttribute('data-merlin-trigger');
        openAdvisor(origin, trigger);
        return;
      }

      const capsuleCard = event.target.closest('.merlin-cart-capsule-card');
      if (capsuleCard && STATE.cartItems) {
        event.preventDefault();
        const idx = parseInt(capsuleCard.getAttribute('data-cart-index'), 10);
        const item = STATE.cartItems[idx];
        if (item) {
          const shortTitle = cleanProductTitle(item.title);
          const cat = classifyItem(item);
          if (cat === 'avize' || cat === 'dekorasyon') {
            handleQuestion(shortTitle + ' hakkında malzeme, boyut ve dekoratif kullanım tavsiyesi alabilir miyim?');
          } else {
            handleQuestion(shortTitle + ' hakkında detaylı kalıp ve stil tavsiyesi alabilir miyim?');
          }
        }
        return;
      }

      const topicBtn = event.target.closest('.merlin-topic-btn');
      if (topicBtn) {
        event.preventDefault();
        const query = topicBtn.getAttribute('data-query') || topicBtn.textContent.replace('+', '').trim();
        handleQuestion(query);
        return;
      }

      if (event.target.id === 'merlin-advisor-backdrop' || event.target.closest('#merlin-advisor-close')) {
        event.preventDefault();
        closeAdvisor();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && STATE.isOpen) {
        closeAdvisor();
      }
    });

    document.addEventListener('submit', function (event) {
      if (event.target && event.target.id === 'merlin-chat-form') {
        event.preventDefault();
        const els = getElements();
        if (els.input) {
          handleQuestion(els.input.value);
        }
      }
    });
  });
})();
